module.exports = __webpack_public_path__ + "media/images/cellphone_generic_full-8007d165.jpg";